var coolAnimatedCollectionBannerScript = {
  init: function () {
    window.addEventListener('load', function(e) {
      coolAnimatedCollectionBannerScript.positionImages(true);
      
      window.addEventListener('scroll', function(e) {
        coolAnimatedCollectionBannerScript.positionImages();
      });
    
      var resizeTimeOut;
      window.addEventListener('resize', function(event) {
        clearTimeout(resizeTimeOut);
        resizeTimeOut = setTimeout(coolAnimatedCollectionBannerScript.positionImages, 300);
      }, true);
      
    });
  },
  positionImages: function (isInit) {
    var minTop = -60;
    var maxTop = 0;
    
    var vw = $(window).width();
    if (vw > 765) {
      var imageWraps = $('.collection-banners.animated').find('.imgWrap.animated');
      for (var i = 0, imgWrap; imgWrap = imageWraps[i]; i++) {
        var height = $(imgWrap).closest('.collection-grid-item')[0].offsetHeight;
        var pixelsInFrame = window.innerHeight - imgWrap.getBoundingClientRect().top;
        if (pixelsInFrame > height) {
          pixelsInFrame = height;
        } 
      
        if (pixelsInFrame > 0) {
          var oldTop = parseFloat(imgWrap.style.top);
          var percShowing = pixelsInFrame / height;
          var offset = Math.round(percShowing * Math.abs(minTop)) + maxTop;
          var newTop = offset - Math.abs(minTop);
        
          if (newTop > maxTop) {
            newTop = maxTop;
          }
          else if (newTop < minTop) {
            newTop = minTop;
          }
    
          imgWrap.style.top = newTop + "px";
        }
        else if (isInit) {
          imgWrap.style.top = minTop + "px";
        } 
      }
    }
  },
}